// Types ComponentsStructureMap used as placeholder.
// Wix CLI will override it inside user's folder with types that based on structure of user's components.
import type { ComponentsStructureMap } from '@wix/blocks/types';
import type { $W } from './internal-types';

type PanelController<P extends Record<string, any>> = ($w: $W<P>) => void;

type DefinePanelFn = <
  P extends keyof ComponentsStructureMap,
  L extends PanelController<ComponentsStructureMap[P]>,
>(
  id: P,
  fn: L,
) => L;

export const definePanel: DefinePanelFn = (_id, fn) => fn;
